'use client';

var EventHelper = /** @class */ (function () {
    function EventHelper() {
        this.on = function (eventName, handler) {
            if (typeof window !== 'undefined') {
                window.addEventListener(eventName, handler);
            }
        };
        this.off = function (eventName, handler) {
            if (typeof window !== 'undefined') {
                window.removeEventListener(eventName, handler);
            }
        };
        this.emit = function (eventName, pamarater) {
            if (typeof window !== 'undefined') {
                var event_1 = new CustomEvent(eventName, pamarater);
                window.dispatchEvent(event_1);
            }
        };
    }
    return EventHelper;
}());
var eventHelper = new EventHelper();

export { eventHelper };
//# sourceMappingURL=helper.js.map
